<template>
  <nav class="navbar" :class="{ scrolled: isScrolled }">
    <div class="nav-inner">
      <!-- Logo -->
      <a href="#home" class="nav-logo">
        <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
        <span class="logo-text">DAILK STER</span>
      </a>

      <!-- Desktop Links -->
      <ul class="nav-links" :class="{ open: menuOpen }">
        <li v-for="link in links" :key="link.id">
          <a :href="'#' + link.id" @click="menuOpen = false">{{
            link.label
          }}</a>
        </li>
      </ul>

      <!-- CTA + Burger -->
      <div class="nav-actions">
        <a href="#contact" class="btn-gold">تواصل معنا</a>
        <button
          class="burger"
          @click="menuOpen = !menuOpen"
          :class="{ active: menuOpen }"
        >
          <span /><span /><span />
        </button>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
const isScrolled = ref(false);
const menuOpen = ref(false);
const links = [
  { id: "services", label: "خدماتنا" },
  { id: "pricing", label: "الأسعار" },
  { id: "portfolio", label: "أعمالنا" },
  { id: "about", label: "من نحن" },
];
const onScroll = () => {
  isScrolled.value = window.scrollY > 60;
};
onMounted(() => window.addEventListener("scroll", onScroll));
onUnmounted(() => window.removeEventListener("scroll", onScroll));
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 1.2rem 2rem;
  transition: all 0.4s ease;
  background: transparent;
}

.navbar.scrolled {
  background: rgba(3, 7, 18, 0.92);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border);
  padding: 0.8rem 2rem;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.5);
}

.nav-inner {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.logo-img {
  height: 50px;
  width: 50px;
  object-fit: contain;
  border-radius: 50%;
  background: var(--bg-navy);
}

.logo-text {
  font-size: 1.3rem;
  font-weight: 900;
  background: linear-gradient(135deg, var(--gold-light), var(--gold));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-links {
  display: flex;
  list-style: none;
  gap: 0.3rem;
  align-items: center;
}

.nav-links a {
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: rgba(245, 245, 240, 0.8);
  border-radius: 8px;
  transition: all 0.3s;
  position: relative;
}

.nav-links a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  right: 50%;
  height: 2px;
  background: var(--gold);
  transition: all 0.3s;
  border-radius: 1px;
}

.nav-links a:hover {
  color: var(--gold);
}
.nav-links a:hover::after {
  left: 10%;
  right: 10%;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.btn-gold {
  background: linear-gradient(135deg, var(--gold), var(--gold-dark));
  color: #000;
  font-weight: 700;
  padding: 0.55rem 1.4rem;
  border-radius: 10px;
  font-size: 0.9rem;
  transition: all 0.3s;
  white-space: nowrap;
  box-shadow: 0 4px 20px var(--gold-glow);
}

.btn-gold:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(212, 175, 55, 0.5);
}

.burger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.burger span {
  display: block;
  width: 24px;
  height: 2px;
  background: var(--gold);
  border-radius: 2px;
  transition: all 0.3s;
}

.burger.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}
.burger.active span:nth-child(2) {
  opacity: 0;
}
.burger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

@media (max-width: 900px) {
  .burger {
    display: flex;
  }

  .nav-links {
    position: fixed;
    top: 0;
    right: -100%;
    width: 270px;
    height: 100vh;
    background: var(--bg-navy);
    border-left: 1px solid var(--border);
    flex-direction: column;
    padding: 5rem 2rem 2rem;
    transition: right 0.35s ease;
    gap: 0.5rem;
  }

  .nav-links.open {
    right: 0;
  }
  .nav-links a {
    font-size: 1.1rem;
    padding: 0.7rem 1rem;
  }
  .logo-text {
    font-size: 15px;
  }
  .btn-gold {
    padding: 3px 7px;
    font-size: 15px;
  }
}
</style>
